import * as urlUtils from 'utils/Url';


export function getPathControlPromptTemplates(qs={}) {
  return urlUtils.appendQueryString(`/control/prompt-templates`, qs);
}

export function getPathControlAddPromptTemplate() {
  return `/control/prompt-templates/add`;
}

export function getPathControlEditPromptTemplate(templateId) {
  return `/control/prompt-templates/${templateId}/edit`;
}

export function getPathControlReplicatePromptTemplate(templateId) {
  return `/control/prompt-templates/${templateId}/replicate`;
}
